export * from './tm-model-home-detail';
export * from './tm-model-home-detail.mock';
